import React, {useEffect, useState} from "react";
import "./GroupPage.sass"
import "../../../_components/common.sass"
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CloseIcon from '@mui/icons-material/Close';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import CheckIcon from '@mui/icons-material/Check';
import AddHomeOutlinedIcon from '@mui/icons-material/AddHomeOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import {ReactComponent as Schedule} from "../../../images/release/schedule.svg";
import {useNavigate, useParams} from "react-router";
import InformationBlock from "../../../_containers/infoblock/InformationBlock";
import CircleButton from "../../../_components/common/buttons/CircleButton";
import {blue, green, red, yellow} from "../../../common/colors";
import UsersTable from "../../../_components/teacher/group/UsersTable";
import {useDispatch, useSelector} from "react-redux";
import {CANCEL, setEmpty} from "../../../_actions/group/groupReducer";
import {setEmpty as setEmptyCommon} from "../../../_actions/commonService";
import {CommonTabsPanel} from "../../../_components/common/tabs/CommonTabsPanel";
import Tab from "../../../_components/common/tabs/Tab";
import TabPanel from "../../../_components/common/tabs/TabPanel";
import TextFieldEdit from "../../../_components/common/fields/TextFieldEdit";
import SelectTextEdit from "../../../_components/common/fields/SelectTextEdit";
import ScheduleComponent from "../../../_components/teacher/group/ScheduleComponent";
import moment from "moment";
import "moment/locale/ru"
import {messageType} from "./MessageHelper";
import _ from "lodash";
import Spinner from "../../common/anonymous/Spinner";
import VisitLogTable from "../../../_components/teacher/group/visitlog/VisitLogTable";
import HomeworkTable from "../../../_components/teacher/group/HomeworkTable";
import {changeState, deleteGroup, getGroupById, getHomework, saveGroup} from "../../../_actions/group/groupService";
import {FAILED, IDLE, LOADING, SUCCESS} from "../../../common/statuses";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import {useSnackbar} from "notistack";
import DialogComponent from "../../../_components/common/dialog/DialogComponent";
import {VisitLogDialog} from "../../../_components/teacher/group/visitlog/VisitLogDialog";

const initScheduleState = {
    monday: undefined,
    tuesday: undefined,
    wednesday: undefined,
    thursday: undefined,
    friday: undefined,
    saturday: undefined,
    sunday: undefined,
}

export default function GroupPage() {
    const {id} = useParams();
    const [isChanging, setChanging] = useState(id === 'null')
    const [groupName, setGroupName] = useState()
    const [courseId, setCourseId] = useState()
    const [cost, setCost] = useState(0)
    const [schedule, setSchedule] = useState(initScheduleState)
    const [openDialog, setOpenDialog] = useState()
    const [closeDialog, setCloseDialog] = useState(false)

    const {courses: myCourses} = useSelector(state => state.auth.current);
    const {data, status} = useSelector(state => state.groups.selected);
    const {status: saveStatus, errors: saveGroupErrors} = useSelector(state => state.groups.save);
    const {status: deleteStatus} = useSelector(state => state.groups.delete);
    const {status: changeStateStatus, errors} = useSelector(state => state.groups.changeState);
    const {status: saveVisitsStatus} = useSelector(state => state.groups.saveVisits);
    const {data: homeworks, status: hwStatus} = useSelector(state => state.groups.getHomeworks);
    const {status: deleteFromGroupStatus} = useSelector(state => state.groups.deleteStudentFromGroup)

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {enqueueSnackbar} = useSnackbar()

    useEffect(() => {
        if (id === 'null') {
            setChanging(true);
        }
        if (status === IDLE && id !== 'null') {
            dispatch(getGroupById(id));
        }
        if (data && !_.isEmpty(data.schedule)) {
            setSchedule(data.schedule);
        }
        if (status === SUCCESS) {
            document.title = 'КьюАй - ' + data.name;
        }
    }, [id, status, dispatch])
    useEffect(() => {
        if (isChanging) {
            if (data) {
                if (id !== 'null') {
                    setGroupName(data.name);
                }
                if (data.course) {
                    setCourseId(data.course.id)
                }
                if (data.cost) {
                    setCost(parseInt(data.cost) / 100);
                }
            }
        }
    }, [id, isChanging, dispatch])
    useEffect(() => {
        if (hwStatus === IDLE && id !== 'null') {
            dispatch(getHomework(id));
        }
    }, [hwStatus, dispatch])
    useEffect(() => {
        if (saveStatus === 'succeeded') {
            dispatch(setEmptyCommon())
            dispatch(setEmpty());
            setChanging(false);
            navigate(`/home/group/${data.id}`);
        }
    }, [saveStatus, dispatch]);
    useEffect(() => {
        if (deleteStatus === SUCCESS) {
            navigate(`/home/schedule`);
        }
    }, [deleteStatus, dispatch]);
    useEffect(() => {
        if (changeStateStatus === SUCCESS) {
            dispatch(setEmpty())
            setCloseDialog(false);
        }
        if (changeStateStatus === FAILED) {
            enqueueSnackbar(errors, {variant: "error"})
        }
    }, [changeStateStatus, dispatch]);
    useEffect(() => {
        if (saveVisitsStatus === SUCCESS) {
            dispatch(setEmpty())
        }
    }, [saveVisitsStatus, dispatch]);
    useEffect(() => {
        document.title = 'КьюАй - Группа'
        return () => {
            setChanging(false);
            setGroupName(undefined);
            setCourseId(undefined);
            setCost(undefined);
            setOpenDialog(undefined);
            setSchedule(initScheduleState);
            dispatch(setEmpty());
            dispatch(setEmptyCommon())
        }
    }, [])

    if (status === LOADING
        || (status === IDLE && id !== 'null')
        || saveStatus === LOADING
        || (deleteStatus === LOADING || deleteStatus === SUCCESS)
        || saveVisitsStatus === LOADING
        || hwStatus === LOADING
        || deleteFromGroupStatus === LOADING) {
        return <Spinner/>
    }

    const handleChangeState = (type) => {
        const {lesson} = data;
        if (!lesson) {
            return () => {
            }
        }
        const req = {
            type: type,
            lessonId: lesson.id
        }
        return () => setOpenDialog({
            type: type,
            action: () => {
                dispatch(changeState(req))
                setOpenDialog(undefined)
            }
        })
    }

    const renderRightPanel = () => {
        return <>
            <div>
                {isChanging
                    ? <CircleButton Icon={SaveOutlinedIcon}
                                    onClick={() => {
                                        dispatch(saveGroup({
                                            id: id === 'null' ? null : data.id,
                                            name: groupName,
                                            course: {
                                                id: courseId
                                            },
                                            cost: cost ? (cost * 100) : 0,
                                            schedule: schedule
                                        }))
                                    }}
                                    title="Сохранить"/>
                    : <CircleButton Icon={SettingsIcon}
                                    onClick={() => setChanging(true)}
                                    title="Изменить"/>
                }
            </div>
            {id !== 'null' &&
                <div>
                    <CircleButton Icon={DeleteOutlineIcon}
                                  title="Удалить"
                                  onClick={() => setOpenDialog({
                                      type: "delete",
                                      action: () => dispatch(deleteGroup(id))
                                  })}/>
                </div>
            }
            <div>
                <CircleButton Icon={CloseIcon}
                              title="Закрыть"
                              onClick={() => {
                                  if (isChanging && id !== "null") {
                                      setChanging(false)
                                  } else {
                                      navigate('/home/schedule')
                                  }
                              }}/>
            </div>
        </>
    }

    const renderCenterButtonPanel = () => {
        const {lesson, students, course} = data;
        const isDisable = lesson ? "" : "group-page-center-info-button-disable"
        const isDisableHW = !_.isEmpty(students) && course.name === "Ментальная арифметика"
            ? ""
            : "group-page-center-info-button-disable"

        return <>
            <div style={{backgroundColor: yellow}}
                 className={`group-page-center-info-button group-page-center-info-button-disable`}>
                <div>
                    <ArrowRightAltIcon/>
                </div>
                <div>Перенести</div>
            </div>
            <div style={{backgroundColor: red}}
                 onClick={handleChangeState(CANCEL)}
                 className={`group-page-center-info-button ${isDisable}`}>
                <div>
                    <CloseIcon/>
                </div>
                <div>Отменить</div>
            </div>
            <div style={{backgroundColor: green}}
                // onClick={handleChangeState(CLOSE)}
                 onClick={() => setCloseDialog(true)}
                 className={`group-page-center-info-button ${isDisable}`}>
                <div>
                    <CheckIcon/>
                </div>
                <div>Завершить</div>
            </div>
            <div style={{backgroundColor: blue}}
                 onClick={_.isEmpty(students) || course.name !== "Ментальная арифметика"
                     ? () => enqueueSnackbar("Задать домашнее задание возможно только в курсе Ментальная арифметика и если в группе есть ученики", {variant: "warning"})
                     : () => navigate(`/home/group/${id}/homework`)}
                 className={`group-page-center-info-button ${isDisableHW}`}>
                <div>
                    <AddHomeOutlinedIcon/>
                </div>
                <div>Задать ДЗ</div>
            </div>
        </>
    }

    const renderTabs = () => {
        return [
            <Tab>Журнал</Tab>,
            <Tab>Домашняя работа</Tab>,
            <Tab>Ученики</Tab>
        ]
    }

    const renderTabPanels = () => {
        return [
            <TabPanel><VisitLogTable/></TabPanel>,
            <TabPanel><HomeworkTable data={homeworks}/></TabPanel>,
            <TabPanel><UsersTable users={data.students}/></TabPanel>
        ]
    }

    const renderTitle = () => {
        if (isChanging) {
            return <TextFieldEdit className="group-page-center-title-text"
                                  label="Название группы"
                                  error={saveGroupErrors && !!saveGroupErrors.name}
                                  helperText={saveGroupErrors && saveGroupErrors.name}
                                  onChange={e => setGroupName(e.target.value)}
                                  value={groupName}/>
        } else {
            return <div className="group-page-center-title-text">{data.name}</div>
        }
    }

    const renderCourse = () => {
        if (isChanging) {
            return <div className="group-page-center-info-item-block">
                <SelectTextEdit label="Курс"
                                value={courseId}
                                onChange={e => setCourseId(e.target.value)}
                                error={saveGroupErrors && !!saveGroupErrors.course}
                                helperText={saveGroupErrors && saveGroupErrors.course}
                                data={myCourses && [...myCourses]
                                    .sort((a, b) => a.id - b.id)
                                    .map(course => {
                                        return {
                                            value: course.id,
                                            name: course.name,
                                        }
                                    })}/>
            </div>
        } else {
            return <>
                <div className="group-page-center-info-item-icon">
                    <SchoolOutlinedIcon/>
                </div>
                <div className="group-page-center-info-item-block">
                    <div className="group-page-center-info-item-title"><b>Курс:</b></div>
                    <div className="group-page-center-info-item-name">
                        {data.course ? data.course.name : "не задан"}
                    </div>
                </div>
            </>
        }
    }

    const renderSchedule = () => {
        if (isChanging) {
            return <ScheduleComponent
                schedule={schedule}
                onChange={(newValue) => setSchedule({...schedule, ...newValue})}/>
        } else {
            const {lesson} = data
            return <>
                <div className="group-page-center-info-item-icon">
                    <AccessTimeOutlinedIcon/>
                </div>
                <div className="group-page-center-info-item-block">
                    <div className="group-page-center-info-item-title"><b>Следующий урок:</b></div>
                    <div className="group-page-center-info-item-name">
                        {
                            lesson
                                ? (`${moment(lesson.date).format('ddd, DD MMMM')} в ${moment(lesson.time, "HH:mm:ss").format('HH:mm')}`)
                                : "не назначен"
                        }
                    </div>
                </div>
            </>
        }
    }

    const renderCost = () => {
        return <>
            <div className="group-page-center-info-item-icon">
                <AccountBalanceWalletOutlinedIcon/>
            </div>
            <div className="group-page-center-info-item-block">
                <div className="group-page-center-info-item-title"><b>Стоимость урока:</b></div>
                <div className="group-page-center-info-item-name">
                    {`${data.cost / 100} рублей`}
                </div>
            </div>
        </>
    }

    return (
        <div className="group-page-wrapper">
            <InformationBlock>
                <div className="group-page-left">
                    <Schedule/>
                </div>
                <div className="group-page-center">
                    <div className="group-page-center-title">
                        {renderTitle()}
                        <div className="group-page-right phone">
                            {renderRightPanel()}
                        </div>
                    </div>
                    <div style={isChanging ? {flexDirection: 'column'} : {}}
                         className="group-page-center-info">
                        <div className="group-page-center-info-item">
                            {renderCourse()}
                        </div>
                        {
                            isChanging && <div className="group-page-center-info-item">
                                <div className="group-page-center-info-item-block">
                                    <TextFieldEdit type="number"
                                                   onChange={(e) => setCost(e.target.value)}
                                                   value={cost}
                                                   label="Стоимость занятия (руб.)"/>
                                </div>
                            </div>
                        }
                        <div className="group-page-center-info-item">
                            {renderSchedule()}
                        </div>
                        {
                            !isChanging && <div className="group-page-center-info-item">
                                {renderCost()}
                            </div>
                        }
                    </div>
                    <div className="group-page-center-info-buttons">
                        {!isChanging && renderCenterButtonPanel()}
                    </div>
                </div>
                <div className="group-page-right full">
                    {renderRightPanel()}
                </div>
            </InformationBlock>
            {!isChanging &&
                <div>
                    <CommonTabsPanel tabs={renderTabs()} tabPanels={renderTabPanels()}/>
                </div>}
            {openDialog && <DialogComponent title={messageType[openDialog.type].title}
                                            buttons={messageType[openDialog.type].buttons}
                                            open={!!openDialog}
                                            onAccept={openDialog.action}
                                            onClose={() => setOpenDialog(null)}>
                {messageType[openDialog.type].content}
            </DialogComponent>}

            {closeDialog && <VisitLogDialog onClose={() => setCloseDialog(false)}
                                            isOpen={closeDialog}/>}
        </div>
    )

}